import {MonitoringService} from '@customer-portal/shared';

MonitoringService.init();
